<div id="component-container" class="form-group" [style.width]="width">
	<input type="text" class="b-inputtext" id="{{inputId}}" name="{{ fieldName }}" placeholder="{{ placeHolderText }}"
		[required]="required" #textInputRef (input)="onTextInput($event)"
		[ngClass]="{ 'error': isError || (!formRef?.get(fieldName).valid && formRef?.get(fieldName).touched),
					 'disabled': (isDisabled ? true : null), 'data-grid-search-input': isSearchField }"
         disabled="{{isDisabled ? true : null}}"
         [value]="_value"
  />

	<i *ngIf="!value && isSearchField" class="search-icon" [iconName]="'search'" title="{{'icon.search.tooltip'|translate}}" ></i>
	<i *ngIf="value && isSearchField" class="clear-search-icon" [iconName]="'cross'" title="{{'btn.close' | translate}}" (click)="onClose(); $event.stopPropagation()"></i>

	<label *ngIf="value && showPlaceholderAsLegend">{{placeHolderText}}</label>

	<div *ngIf="hasError" class="help-block error-message-text">
		<ng-content></ng-content>
	</div>
</div>
